import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import { ProjectInput } from "entities/projects/ui/project-input/ProjectInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface ProjectInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomProjectInput = React.memo(
  ({ className, hideLabel }: ProjectInputProps) => {
    const {
      isReadonly,
      isDisabled,
      projectOptions,
      isLoadingProjectOptions,
      hideProject
    } = useRoomFormContext()

    if (hideProject) return null

    return (
      <ProjectInput
        className={classNames("room-form__project", className)}
        hideLabel={hideLabel}
        items={projectOptions}
        loading={isLoadingProjectOptions}
        readonly={isReadonly}
        disabled={isDisabled}
        data-testid="room__project__combobox"
      />
    )
  }
)
